import { render, staticRenderFns } from "./ProductImageGallery.vue?vue&type=template&id=2149eeda&scoped=true"
import script from "./ProductImageGallery.vue?vue&type=script&lang=js"
export * from "./ProductImageGallery.vue?vue&type=script&lang=js"
import style0 from "./ProductImageGallery.vue?vue&type=style&index=0&id=2149eeda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2149eeda",
  null
  
)

export default component.exports